module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-006",
      "role": "doc-chapter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "role": "doc-pagebreak",
      "title": "36"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("3"), _c('br'), _c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Image",
      "id": "filet_5",
      "src": "images/filet.jpg"
    }
  })])]), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('i', [_vm._v("The")]), _vm._v(" HOLY SPIRIT "), _c('i', [_vm._v("in ")]), _vm._v("LUKE")])]), _c('h1', {
    staticClass: "chap_stit",
    attrs: {
      "epub:type": "subtitle",
      "role": "doc-subtitle"
    }
  }, [_c('span', [_vm._v("GOOD NEWS FOR THE POOR AND FREEDOM"), _c('br'), _vm._v("FOR THE CAPTIVES"), _c('br'), _c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Image",
      "id": "filet_6",
      "src": "images/filet.jpg"
    }
  })])]), _c('div', {
    staticClass: "exergues"
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_c('i', [_vm._v("The Spirit of the Lord is on me, because he has anointed me to proclaim good news to the poor. He has sent me to proclaim freedom for the prisoners and recovery of sight for the blind, to set the oppressed free, to proclaim the year of the Lord’s favor.")])]), _c('div', {
    staticClass: "exer_source"
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UKE 4:18-19")]), _vm._v(" NIV")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UKE CAN RIGHTLY")]), _vm._v(" be called a “theologian of the Spirit.” He intuitively joins any thought about God with the person and work of the Holy Spirit. In fact, Luke mentions the Holy Spirit nearly as much as Matthew and Mark combined. When one considers the number of times the Spirit appears in the book of Acts, the companion volume to Luke, Luke references the Holy Spirit over seventy times in his writings."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-032",
      "id": "ap_ntb-032-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Yet it is not the number of references that is important here. What really matters is how exceptional the Spirit is for Luke. Simply put, there is no presence of God without the Holy Spirit. For example, the birth narratives in Luke, the longest and most complete in the Bible, are permeated with the work of the Spirit. John the Baptist was filled with the Holy Spirit before he was even born (Lk 1:15)! The last words "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37",
      "role": "doc-pagebreak",
      "title": "37"
    }
  }, [_vm._v("of the exalted Christ are for the disciples to receive the promise of the Spirit (Lk 24:49).")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For Luke, no person or event has any constructive role in the kingdom apart from the Spirit. The birth narratives are replete with references to persons filled with the Spirit and prophesying. Once Jesus receives the Spirit at his baptism, he is the sole locus of the Spirit in the world. Up until the Day of Pentecost, no one else operates in the Spirit except Jesus. So the Spirit is both programmatic and paradigmatic for the life and ministry of Jesus. The Spirit not only sets the agenda for Jesus’ actualization of the kingdom, the Spirit establishes the pattern of how God now works in the world. This program and pattern in the Spirit began with Jesus and will continue by way of his church.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As such, the first great event of Jesus’ ministry was not an exorcism or healing as was the case in Matthew and Mark. Rather, what would determine the quality and content of Jesus’ ministry were the words he spoke in the synagogue in Nazareth. When Jesus said, “The Spirit of the Lord is upon me,” he determined the entire basis of his ministry. Isaiah’s prophecy inaugurated the Spirit-anointed ministry of Christ, together with all of the charisms of his ministry (Lk 4:18-19; Isa 61:1-2)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-033",
      "id": "ap_ntb-033-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" It meant that the word and work of Jesus is good news for the poor, deliverance for the captives, healing for the infirmed, and freedom for the oppressed."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-034",
      "id": "ap_ntb-034-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Now is the time for the Lord’s good favor to be realized on earth. All of this happens through the person and power of the Holy Spirit.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Indeed for Luke, the manifold nature and gifts of the Spirit are preeminently set forth in the life and ministry of Jesus. The Spirit is a Spirit of joy who welcomes those who are outside the boundaries of Judaism. The Holy Spirit in Luke is the Spirit of justice who cares for the poor and oppressed. Overall, the Spirit in Luke is extraordinarily positive. When the Spirit is present, there is praise, singing, and prophecy. On the other hand, to speak and act contrary to the Spirit invites judgment.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_38",
      "role": "doc-pagebreak",
      "title": "38"
    }
  }, [_vm._v("Luke’s vision of the Spirit has come down to us through the ages. His record of the Spirit is something to cultivate, to pray about, and to receive.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-015"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUSE FOR")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAYER")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Luke has quite a bit to say about the Samaritans in his Gospel (see Lk 9:52; 10:33; 17:16). Bad blood had existed between the Jews and the Samaritans for hundreds of years (see Ezra 4:1-4)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-035",
      "id": "ap_ntb-035-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" That is why when Jesus and his disciples were traveling to Jerusalem, some Samaritans barred them from passing through their village. Indignant, James and John, the “Sons of Thunder,” want to call down fire and destroy the Samaritans in the manner of Sodom and Gomorrah. Jesus rebuked them and then chose another path (Lk 9:52-56). Some later manuscripts have Jesus saying, “You do not know what kind of spirit you are of; for the Son of Man did not come to destroy men’s lives, but to save them.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Racial prejudice had poisoned the spirits of James and John. Yet Jesus’ rebuke gets the point across. The Spirit always helps, never harms. We must build others up in the Spirit and be conduits of God’s grace. Anything less is “to grieve the Holy Spirit” (Eph 4:29-30). Pray now that you will always seek the leading of the Spirit to help and not to hurt. Such prayers become especially important when you feel slighted or mistreated, as James and John apparently felt.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-016"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESENCE OF THE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLY")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT IN")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UKE")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_c('i', [_vm._v("The Holy Spirit and two extraordinary births (Lk 1:1–2:40).")])]), _vm._v(" If Mark completely skips the birth narrative of Jesus, and Matthew records everything from Joseph’s perspective, Luke doubles down on the subject. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_39",
      "role": "doc-pagebreak",
      "title": "39"
    }
  }, [_vm._v("He not only records the miracle of the virgin birth, but he alone records the birth of John the Baptist. Perhaps because he is a physician, Luke records everything from the perspective of the mothers.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The Spirit is intensely active in Luke’s birth narrative. John the Baptist was full of the Holy Spirit while still in his mother’s womb. When Mary greets Elizabeth, the yet unborn John moves suddenly in the womb, and his mother is filled with the Spirit. Once born, John’s father Zechariah is also filled with the Holy Spirit and prophesies. When describing the role of the Spirit in the virgin birth, Luke uses the word "), _c('i', [_vm._v("episkiazō ")]), _vm._v("or “overshadow” (Lk 1:35). The image of the Spirit overshadowing Mary is reminiscent of the Spirit hovering over the waters in creation (Gen 1:2).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Everyone associated with the birth of Jesus and John is influenced by the Holy Spirit. Zechariah is filled with the Spirit and prophesies. The Spirit guides the aged Simeon to the temple so that he can meet the holy family. Simeon prophesies in the Spirit, who reveals to him that Jesus will be a light to the Gentiles (Lk 2:25-35).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Luke wants his readers to know that the Holy Spirit effects the birth of Christ and inaugurates the messianic age. It is the Spirit who reveals, fills, overshadows, conceives, moves, and prophesies.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("The Holy Spirit and the charismatic ministry of Christ (Lk 4:1-21; 7:17-23). ")])]), _vm._v("Luke is the only Gospel to say that Jesus was full of the Holy Spirit "), _c('i', [_vm._v("before")]), _vm._v(" and "), _c('i', [_vm._v("after")]), _vm._v(" his temptation in the wilderness (Lk 4:1, 14). Moreover, Jesus predicates his entire ministry on the words, “The Spirit of the Lord is upon me” (Lk 4:18-19). When the disciples of John the Baptist inquire whether Jesus is the Christ (Lk 7:19-20), Jesus rehearses a litany of divine works recalling his words in Nazareth (see Lk 4:18-19).The blind are made to see, the lame can walk again, lepers are cleansed, the deaf hear, the dead are raised, and most importantly for Luke, the gospel is preached to the poor. In sum, the proof that Jesus is the Messiah is seen in his Spirit-anointed deliverance ministry that empowers the poor and heals the infirmed.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Some of the spiritual warfare so evident in Matthew and Mark is also present in Luke. In Luke, Jesus states that he drives out demons “by the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_40",
      "role": "doc-pagebreak",
      "title": "40"
    }
  }, [_vm._v("finger of God” (Lk 11:20)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-036",
      "id": "ap_ntb-036-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" When threatened by Herod Antipas, Jesus responds that he casts out demons on an ongoing basis (Lk 13:32). In every case, it is the Holy Spirit that defeats the powers of darkness.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("The Holy Spirit and social justice (Lk 1:53; 3:1-17; 6:20-38; 12:14-21; 14:12-24; 16:1-13, 19-31).")])]), _vm._v(" God’s care for the poor is a constant refrain in Luke. Mary is thankful that God has filled the hungry and sent the rich away empty. Luke describes the ministry of John the Baptist as caring for the poor and powerless. Those who have a surplus should share with those in need. Those in power should enact fair taxes. No one should use power to extort money from the innocent. For Jesus, the kingdom has drawn near when the good news is preached to the poor (Lk 4:18; 7:22). Matthew has “Blessed are the poor "), _c('i', [_vm._v("in spirit")]), _vm._v(",” but Luke simply says, “Blessed are you who are poor” (Mt 5:3; Lk 6:20). Twice in Luke, Jesus commands someone to sell everything and give to the poor (Lk 12:33; 18:22). On the other hand, the rich should mourn because judgment is coming. You simply can’t serve God and money.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Only Luke has the parable of the rich fool and the pitiful yet terrifying story of the rich man and Lazarus. Material riches mean nothing if you’re spiritually poor (Lk 12:21). Those who hoard wealth and have no care for the poor can expect judgment. Where one’s treasure is, there one’s heart will be also (Lk 12:34). We should give to persons who cannot afford to repay us."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-037",
      "id": "ap_ntb-037-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" It is the poor and powerless who will sit at God’s banquet table. For Luke, benevolence to the poor fulfills all the purity regulations (Lk 11:41).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In sum, Luke empowers the poor and turns the values of this world upside down (Lk 9:57-62). What people hold in high esteem is repugnant to God. Jesus has come to set this earth on fire. Allegiance to him takes precedence over family ties (Lk 12:49-53). The only answer to materialism is to make Jesus your sole possession.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_41",
      "role": "doc-pagebreak",
      "title": "41"
    }
  }, [_c('b', [_c('i', [_vm._v("The Holy Spirit and crosscultural mission (Lk 2:32; 4:26-27; 7:2-9; 10:27-37).")])]), _vm._v(" The Holy Spirit in Luke is expansive and welcoming. The redemptive power of God in Christ bursts through the confines of Judaism and reaches out to Gentiles. The aged Simeon prophecies that Jesus will be a light of revelation for the Gentiles. The widow of Zarephath and Naaman the Syrian are commended for their faith. The same holds true for centurions and Samaritans—often they alone are thankful to God. The soul of every person, even a despised Samaritan, is precious to God.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("The Holy Spirit is the Spirit of joy (Lk 1:46-55, 67-79; 2:13-14; 6:22-23; 15:1-32).")])]), _vm._v(" Compared to the empty frivolity of the world, the kingdom can appear severe. In the main, however, the Spirit of God is a Spirit of joy. In Luke, people on earth and angels in heaven are singing for joy. Even when persecuted, the disciples are to rejoice and leap for joy. Upon return, the seventy-two disciples are full of joy (Lk 10:17). Jesus is full of the joy of the Holy Spirit (Lk 10:21). Moreover, the parables of the lost sheep, lost coin, and lost son, all unique to Luke, are full of joy and rejoicing. And finally, after the ascension of Christ, the disciples return to Jerusalem with great joy (Lk 24:52). Outside of the kingdom it may be dark and dire, but within there is unspeakable joy.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("The Holy Spirit is the promise of the Father (Lk 11:1-13; 24:49-52).")])]), _vm._v(" Prior to his ascension, Jesus makes an extraordinary promise to his disciples. He will send “power from on high,” the promised Holy Spirit of the Father (Lk 24:49). This prediction of Pentecost forms a perfect segue to the book of Acts (see Acts 1:8; 2:1-4). Luke’s message is clear. What Jesus began to do in the Spirit during his earthly ministry, he will continue to do through the Spirit in the church.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The Lord’s Prayer forms the immediate context for the promised gift of the Holy Spirit. In that prayer, all the provision of the Father, both spiritual (the forgiveness of sins) and material (the granting of daily bread) comes by way of God’s ultimate provision, the indescribable gift of the Spirit. It is God’s benevolent will to give the Holy Spirit to all who ask him.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-017"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_42",
      "role": "doc-pagebreak",
      "title": "42"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UMMARY")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOUGHTS")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Luke is a theologian of the Spirit. The Spirit is prophetically active before Jesus is born, indwells John the Baptist while still in the womb, and empowers Jesus from the time of his baptism in water until the moment he is taken up into heaven at the ascension. The Spirit directs Jesus to preach the gospel to the poor, set free those who have been taken captive, heal the infirmed, and deliver those who have been oppressed. Through the Spirit, Jesus is realizing the kingdom in joy. The unmatched benevolence of the Father assures that through Jesus, the person and power of the Spirit will be gifted to the church. The gift of the Spirit is the source of all spiritual gifts and ensures that the kingdom will proceed in power until the Lord’s return.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-018"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OES")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("T")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAN FOR")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E?")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("For Luke, the Holy Spirit is not some distant theological abstraction. The Spirit is the genuine and personal presence of God that is experienced in everyday life (Lk 1:5-8; 2:8-11; 3:1-3). It is a comfort to know that the Spirit provides an unfettered communion with the Almighty. It is a challenge to realize that the voice of God is an ever-present reality to be heard and obeyed. The imminence of the Spirit behooves the sensitive believer to pray without ceasing (1 Thess 5:17).")]), _c('ul', {
    staticClass: "liste_image"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("The Spirit in Luke clearly reaches out to persons on the fringes of society. Pray now that you might truly sense the longing of the Spirit for the marginalized and by that same Spirit be used to alleviate their suffering.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("The Holy Spirit in Luke is a very positive Spirit. However, along with this positivity, Luke has interwoven an element of judgment. Everything that agrees with the Spirit is affirmed. Everything that conflicts with the Spirit is rejected. In this regard, we are to “step in the same footprints” as the Spirit (2 Cor 12:18). If we claim unrestricted communion with the Spirit, we should pray that our steps be ordered by the Spirit.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_43",
      "role": "doc-pagebreak",
      "title": "43"
    }
  }, [_vm._v("The heart of the Holy Spirit is a joyful heart. Does your heart reflect the joy of the Spirit? A preeminent fruit of the Spirit is joy. Paul says that bitterness and harmful speech grieve the Holy Spirit (Eph 4:30-31). Pray that the Holy Spirit will reveal the deep recesses of your heart and expose those areas in need of joy-filled grace.")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("It is the Father’s good pleasure to give the Holy Spirit to all who ask. In one sense, we should keep on asking. Paul welcomed the prayers of the Philippians concerning the “provision of the Spirit” in his life (Phil 1:19) Pray that you might always be asking the Father to grant you a continual supply of his Holy Spirit.")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d40e346","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap3.vue
// module id = 78
// module chunks = 0